import script from "./fad-list.vue?vue&type=script&lang=js&setup=true"
export * from "./fad-list.vue?vue&type=script&lang=js&setup=true"

const __exports__ = script;

export default __exports__